Object.defineProperty(exports, '__esModule', { value: true });

const core = require('@sentry/core');

const WINDOW = core.GLOBAL_OBJ

;

exports.WINDOW = WINDOW;
//# sourceMappingURL=types.js.map
